import { Routes, Route } from 'react-router-dom';

import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import ExperienceTimeline from '../components/Experience/ExperienceTimeline';
import Marquee from '../components/Marquee/Marquee';
import AiLab from '../components/AiLab/AiLab';
import Works from '../components/Works/Works';
import Skill from '../components/Skill/Skill';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
import Intro from '../components/About/RouteComponents/Intro';
import Experience from '../components/About/RouteComponents/Experience';
import ScrollManager from '../components/Layout/ScrollManager';
import SubPageLayout from '../components/Layout/SubPageLayout';
import NotFound from '../components/Layout/NotFound';
import Background from '../components/Effects/Background';
import CursorGlow from '../components/Effects/CursorGlow';
import ScrollProgress from '../components/Effects/ScrollProgress';
import Preloader from '../components/Effects/Preloader';

function HomePage() {
  return (
    <>
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <Marquee />
        <About />
        <ExperienceTimeline />
        <AiLab />
        <Works />
        <Skill />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default function AppRoutes() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Preloader />
      <Background />
      <CursorGlow />
      <ScrollProgress />
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/about/intro"
          element={
            <SubPageLayout>
              <Intro />
            </SubPageLayout>
          }
        />
        <Route
          path="/about/experience"
          element={
            <SubPageLayout>
              <Experience />
            </SubPageLayout>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
